import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

const Header = ({ callNumber = '(346) 258-0006', tel = 'tel:3462580006' }) => {
  return (
    <header className="sticky top-0 z-40 bg-paper/90 backdrop-blur-sm border-b border-hair">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="av-wave" aria-hidden="true" style={{ height: 22 }}>
              <span /><span /><span /><span /><span /><span /><span />
            </span>
            <span className="text-xl font-bold uppercase tracking-[0.14em] text-ink">Alfred Voice</span>
          </Link>

          <nav className="flex items-center gap-7">
            <a href="#talk-to-alfred" className="hidden md:inline text-slateink hover:text-brass text-xs font-medium uppercase tracking-[0.1em] transition-colors">Hear Alfred</a>
            <a href="#pricing" className="hidden md:inline text-slateink hover:text-brass text-xs font-medium uppercase tracking-[0.1em] transition-colors">Pricing</a>
            <Link to="/login" className="hidden md:inline text-slateink hover:text-brass text-xs font-medium uppercase tracking-[0.1em] transition-colors">Sign in</Link>
            {/* Style guide: the phone CTA outranks everything else on every screen. */}
            <a href={tel} className="av-btn-brass px-4 py-2 text-xs">
              <Phone className="w-3.5 h-3.5" /> {callNumber}
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
